import { isNil } from "lodash-es";

import { ICodelist } from "@/data/codelists";

export const jobApplicationFiltersMapper = {
  showClosed: (v?: boolean | null) => (isNil(v) ? undefined : v),
  query: (v: string) => (isNil(v) ? undefined : v),
  contactPersonProfileIds: (v: Array<number>) => (isNil(v) ? undefined : v),
  status: (v: ICodelist[]) => (isNil(v) ? undefined : v.map(o => o.code)),
  candidateIds: (v: Array<number>) => (isNil(v) ? undefined : v),
};
